import { decodeHtmlEntities } from '@opallabs/lambda'

export const setReactModularSectionOptionData = (postOption) => {
  const option = postOption.option_record.option

  let textValue = ''
  let selectedValue = {}
  let selectOptions = null
  if (option.input_type === 'select') {
    // A placeholder select one option for when a selection has been made and the user
    // needs to deselect/clear their value
    selectOptions = []
    // Parsing selections metadata for Select dropdown component
    option.meta_data.selections.map((value, index) =>
      selectOptions.push({
        id: index + 1,
        title: value.display_name,
      })
    )
    // Get the selected value and add a 'deselect' option if needed
    const selected = postOption.value
    selectedValue = selectOptions.find(
      (selections) => selections.title === selected
    )
    if (selectedValue) {
      selectOptions.unshift({ id: 0, title: 'Select One...' })
    }
  } else {
    textValue = decodeHtmlEntities(postOption.value)
  }

  return {
    content: selectOptions || textValue,
    group_id: 0,
    group: option.group_name,
    option: option.display_name,
    required: option.required,
    selected: selectedValue,
    type: option.input_type,
    validation: option.meta_data.validation || '',
  }
}
